module.exports = __webpack_public_path__ + "d0ee679606d61927c07324fee765d19f.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-lightitalic.ttf
 ** module id = 7
 ** module chunks = 0
 **/